import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useRole } from '../context/RoleContext';
import {
  ListChecks,
  Users,
  Settings,
  LogOut,
  Calculator,
  Calendar,
  ChevronRight,
  FileText,
  LayoutDashboard,
  Briefcase,
  Receipt,
  TrendingUp,
} from 'lucide-react';

const MoreMobile = () => {
  const { logout } = useAuth();
  const { role } = useRole();

  // Menu items grouped by section
  const menuSections = [
    {
      title: 'Quick Access',
      items: [
        { name: 'Dashboard',  href: '/dashboard', icon: LayoutDashboard, roles: ['owner', 'admin'] },
        { name: 'Jobs',       href: '/jobs',       icon: Briefcase,       roles: ['owner', 'admin', 'sales', 'technician', 'marketing'] },
        { name: 'Leads',      href: '/leads',      icon: ListChecks,      roles: ['owner', 'admin', 'sales', 'marketing'] },
        { name: 'Clients',    href: '/clients',    icon: Users,           roles: ['owner', 'admin', 'sales', 'technician'] },
        { name: 'Quotes',     href: '/quotes',     icon: FileText,        roles: ['owner', 'admin', 'sales'] },
        { name: 'Invoices',   href: '/invoices',   icon: Receipt,         roles: ['owner', 'admin', 'sales'] },
        { name: 'Forecast',   href: '/forecast',   icon: TrendingUp,      roles: ['owner', 'admin', 'sales'] },
        { name: 'Calculator', href: '/calculator', icon: Calculator,      roles: ['owner', 'admin', 'sales'] },
        { name: 'Calendar',   href: '/calendar',   icon: Calendar,        roles: ['owner', 'admin', 'sales', 'technician', 'marketing'], note: 'View only on mobile' },
      ],
    },
    {
      title: 'Account',
      items: [
        { name: 'Settings', href: '/settings', icon: Settings, roles: ['owner', 'admin'] },
      ],
    },
  ];

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-4 sticky top-0 z-10">
        <h1 className="text-xl font-bold text-[var(--cb-navy)]">More</h1>
      </div>

      {/* Menu Sections */}
      <div className="px-4 py-4 space-y-6">
        {menuSections.map((section) => {
          const visibleItems = section.items.filter(item => item.roles.includes(role));
          if (visibleItems.length === 0) return null;

          return (
            <div key={section.title}>
              <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 px-1">
                {section.title}
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 overflow-hidden divide-y divide-gray-100">
                {visibleItems.map((item) => {
                  const Icon = item.icon;

                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="flex items-center gap-3 px-4 py-3.5 hover:bg-gray-50 active:bg-gray-100 transition-colors"
                      data-testid={`more-mobile-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      <Icon className="h-5 w-5 text-gray-600" />
                      <div className="flex-1">
                        <span className="font-medium text-[var(--cb-navy)]">{item.name}</span>
                        {item.note && (
                          <p className="text-xs text-gray-400 mt-0.5">{item.note}</p>
                        )}
                      </div>
                      <ChevronRight className="h-5 w-5 text-gray-300" />
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}

        {/* Sign Out */}
        <div>
          <button
            onClick={handleSignOut}
            data-testid="more-mobile-sign-out-btn"
            className="w-full flex items-center gap-3 px-4 py-3.5 bg-white rounded-xl border border-gray-200 hover:bg-gray-50 active:bg-gray-100 transition-colors"
          >
            <LogOut className="h-5 w-5 text-red-500" />
            <span className="font-medium text-red-500">Sign Out</span>
          </button>
        </div>

        {/* Version */}
        <div className="text-center text-xs text-gray-400 pt-4">
          <p>KRO Mobile</p>
          <p className="mt-0.5">v1.0.0</p>
        </div>
      </div>
    </div>
  );
};

export default MoreMobile;
